import { render, staticRenderFns } from "./PrintTransportation.vue?vue&type=template&id=bb96f95c&"
import script from "./PrintTransportation.vue?vue&type=script&lang=js&"
export * from "./PrintTransportation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports